import { useState } from 'react';

import { translate } from '@chaika/i18n/helper';

export enum PartOfErrorMessages {
    SessionExpired = 'session expired',
    AlreadySent = 'Письмо уже отправлено на email',
    UserNotFound = 'User not found',
    UserNotFoundRu = 'Пользователь с email',
    WrongPassword = 'Неверный пароль',
}

interface UseAuthErrorsReturn {
    errorMessage?: string;
    userErrorMessage?: string;
    passwordErrorMessage?: string;
    setFromError(e: any): void;
    setUserErrorMessage(message: string): void;
    setPasswordErrorMessage(message: string): void;
    reset(): void;
}

export function useAuthErrors(): UseAuthErrorsReturn {
    const [errorMessage, setErrorMessage] = useState<string>();
    const [userErrorMessage, setUserErrorMessage] = useState<string>();
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<string>();

    function setFromError(e: any): void {
        const error = e as Error;
        const message = error.message;

        if (message.includes(PartOfErrorMessages.SessionExpired)) {
            setErrorMessage(`${translate('sessionExpired')}. ${translate('loginAgain')}`);
        } else if (message.includes(PartOfErrorMessages.AlreadySent)) {
            setErrorMessage(translate('alreadySent'));
        } else if (
            message.includes(PartOfErrorMessages.UserNotFound) ||
            message.includes(PartOfErrorMessages.UserNotFoundRu)
        ) {
            setUserErrorMessage(`${translate('userNotFound')}\n${translate('checkEmail')}`);
        } else if (message.includes(PartOfErrorMessages.WrongPassword)) {
            setPasswordErrorMessage(translate('wrongPassword'));
        } else {
            setErrorMessage(message);
        }

        setTimeout(() => reset(), 20000);
    }

    function reset(): void {
        setErrorMessage(undefined);
        setUserErrorMessage(undefined);
        setPasswordErrorMessage(undefined);
    }

    return {
        errorMessage,
        userErrorMessage,
        passwordErrorMessage,
        setFromError,
        setUserErrorMessage,
        setPasswordErrorMessage,
        reset,
    };
}
